module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br')])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e8b0df4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e8b0df4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PortalForm.vue
// module id = 540
// module chunks = 4